module.exports = __webpack_public_path__ + "media/assets/images/smart_working/personas-1-8b276e174a673ca7d33ea2d5e64b5926.jpg";